import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "../../css/Mirissa.css";

import { storage } from "../../firebase";
import { ref, getDownloadURL } from "firebase/storage";

function NuwaraEliya() {

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const [imgHero, setImgHero] = useState("");

  // MAIN GALLERY
  const [n1, setN1] = useState("");
  const [n2, setN2] = useState("");

  // EXTRA GALLERY
  const [n3, setN3] = useState("");
  const [n4, setN4] = useState("");
  const [n5, setN5] = useState("");

  const [hortonPlains, setHortonPlains] = useState("");
  const [moonPlains, setMoonPlains] = useState("");
  const [gregoryLake, setGregoryLake] = useState("");
  const [sitaTemple, setSitaTemple] = useState("");
  const [golfClub, setGolfClub] = useState("");
  const [victoriaPark, setVictoriaPark] = useState("");
  const [trainRides, settrainRides] = useState("");
  const [waterfalls, setWaterfalls] = useState("");
  const [ambewelaFarm, setAmbewelaFarm] = useState("");

  const [n6, setN6] = useState("");
  const [n7, setN7] = useState("");

  useEffect(() => {

    getDownloadURL(ref(storage, "nuwara-eliya-hero.jpg")).then(setImgHero);

    // TOP GALLERY
    getDownloadURL(ref(storage, "nuwaraEliya1.jpg")).then(setN1);
    getDownloadURL(ref(storage, "nuwaraEliya2.jpg")).then(setN2);

    // EXTRA GALLERY
    getDownloadURL(ref(storage, "nuwaraEliya3.jpg")).then(setN3);
    getDownloadURL(ref(storage, "nuwaraEliya4.jpg")).then(setN4);
    getDownloadURL(ref(storage, "nuwaraEliya5.jpg")).then(setN5);

    // ACTIVITIES – Nature
    getDownloadURL(ref(storage, "Horton Plains.png")).then(setHortonPlains);
    getDownloadURL(ref(storage, "Moon Plains.png")).then(setMoonPlains);
    getDownloadURL(ref(storage, "Gregory Lake.png")).then(setGregoryLake);
    getDownloadURL(ref(storage, "Sita Amman Temple.png")).then(setSitaTemple);
    getDownloadURL(ref(storage, "Golf Club.png")).then(setGolfClub);
    getDownloadURL(ref(storage, "Victoria Park.png")).then(setVictoriaPark);
    getDownloadURL(ref(storage, "Train rides.png")).then(settrainRides);
    getDownloadURL(ref(storage, "Waterfalls.png")).then(setWaterfalls);
    getDownloadURL(ref(storage, "Ambewela Farm.png")).then(setAmbewelaFarm);

    getDownloadURL(ref(storage, "nuwaraEliya6.jpg")).then(setN6);
    getDownloadURL(ref(storage, "nuwaraEliya7.jpg")).then(setN7);

  }, []);

  return (
    <div className="destination-container">
      {/* HERO SECTION */}
      <section
        className="mirissa-hero"
        style={{ backgroundImage: `url(${imgHero})` }}
        data-aos="fade-down"
      >
        <div className="overlay">
          <h1>Nuwara Eliya</h1>
        </div>
      </section>

      {/* MAIN CONTENT */}
      <section className="mirissa-container">

        {/* LEFT CONTENT */}
        <div className="mirissa-left" data-aos="fade-right">

          <h2>Nuwara Eliya</h2>
          <p>
            Nuwara eliya is also called as Little England.
          </p>

          <h2>
            Main attractions in Nuwara Eliya:
          </h2>

          <h3>Climate:</h3>
          <p>
            Fresh and invigorating, similar to the European spring, making it an ideal refuge from the tropical heat.
          </p>

          <h3>Tea plantations:</h3>
          <p>
            Surrounded by hills with rolling tea plantations; excursions to places like the Pedro tea plantation are popular.
          </p>

          <h3>Colonial architecture:</h3>
          <p>
            : It has charming buildings inspired by the United Kingdom, including hotels, post offices, and clubs.
          </p>

          <h3>Nature and Adventure:</h3>
          <p>
            The site of Horton Plains National Park, Gregory Lake, and countless waterfalls.
          </p>

          <div className="mirissa-gallery">
            <img src={n1} alt="Nuwara Eliya" />
            <img src={n2} alt="Nuwara Eliya" />
          </div>

          <h3>Activities in nuwara eliya</h3>

          <ul className="mirissa-list">
            <li>Horton plains national park</li>
            <li>Train ride nuwara eliya ( Nanu Oya) to Ela</li>
            <li>Gregory lake</li>
            <li>Victoria park</li>
            <li>Hakgala botanical garden</li>
            <li>Ambewela farm</li>
            <li>Sethaamman temple</li>
            <li>Golf club</li>
            <li>Moon plains</li>
            <li>Pedro tea state</li>
            <li>Ramboda fall</li>
            <li>Damro Tea factory</li>
          </ul>

          {/* EXTRA CONTENT FROM SCREENSHOT */}
          <div className="mirissa-extra" data-aos="fade-up">

            <div className="mirissa-top-gallery">
              <img src={n3} alt="Nuwara Eliya" />
              <img src={n4} alt="Nuwara Eliya" />
              <img src={n5} alt="Nuwara Eliya" />
            </div>

            <h2>Horton plains national park</h2>

            <p>
              Horton Plains National Park is a UNESCO World Heritage Site in Sri Lanka,
              known for its unique biodiversity and stunning landscapes. Located in the central highlands,
              it includes grasslands, montane forests, and attractions such as World's End (a cliff with panoramic views),
              Baker's Falls, and Baken.
            </p>

            <p>
              In the park, there is a diversity of wildlife, including sambar deer, leopards, and many endemic bird species.
              The 9.5-kilometer loop offers an unforgettable hike through this calm and misty plateau.
              This is a must-visit place for nature lovers and tourists.
            </p>

            <h3>Highlights:</h3>

            <p>
              A world on the edge: A dramatic cliff at 870 meters that offers panoramic views over the valley below, especially charming during the clear morning hours.
            </p>

            <p>
              Baker falls: A picturesque waterfall surrounded by lush vegetation, accessible via panoramic trails.
            </p>

            <p>
              Flora and Fauna: Home to rare species, such as Sri Lanka's sambur deer, purple-faced langurs, and endemic birds.
            </p>

            <p>
              Trekking trails: Well-marked circular trails through prairies, misty forests, and foggy mountains.
            </p>

            <p>
              Climate and view: The cool and misty weather gives the park an ethereal charm.
            </p>

            <h3>Tips for the visit:</h3>

            <p>
              Arrive early (around 6:00 AM) to avoid fog that can obscure visibility.
            </p>

            <p>
              Put on comfortable shoes and bring warm clothes.
            </p>

            <p>
              It's better to explore the park on foot; motor vehicles are restricted inside.
            </p>

            <p>
              You can include this destinations in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience
            </p>

            <h2>Train ride nuwara eliya ( Nanu Oya) to Ela</h2>

            <p>
              This is one of the most scenic train journeys in the world.
              This journey will take you through green tea plantations, misty mountains, and charming villages,
              offering breathtaking views at every turn.
              The landscapes take your breath away: Wavy tea plantations, roaring waterfalls, and dense forests.
            </p>

            <p>
              Iconic bridges: Cross monuments like the Nine Arches Bridge near Ella.
            </p>

            <p>
              The landscapes are impressive: Tea plantations, roaring waterfalls, and dense forests.
            </p>

            <p>
              Fresh climate: The journey is refreshing thanks to the altitude and mountain breezes.
            </p>

            <p>
              Charming stations: Picturesque stops, such as Nanu Oya (on the way to Nuwara Eliya) and Demodara, enrich the experience.
            </p>

            <p>
              Local culture: Enjoy the lively atmosphere with vendors offering snacks like samosas and vadas.
            </p>

            <p>
              Travel tip: Duration: Approximately 3-4 hours. Photography: Have your camera ready; every turn reveals a new view.
              You can include this destinations in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience
            </p>

            <h2>Gregory lake</h2>

            <p>
              it is a beautiful lake located in the heart of Nuwara Eliya, Sri Lanka.
              It was created in 1873 during the British colonial period under the supervision of the British governor Sir William Gregory.
            </p>

            <h3>Here are some points:</h3>

            <p>
              Natural beauty: The lake is surrounded by green hills and offers a picturesque view.
              It is a popular spot for picnics and peaceful walks.
            </p>

            <p>
              Recreational activities: Visitors can enjoy various activities, such as boat trips, pony rides, and bike tours around the lake.
              There are also swan-shaped pedal boats for a fun and unique experience.
              Calm atmosphere: The calm waters and peaceful surroundings make this place an ideal spot to relax and find peace.
            </p>

            <p>
              Calm atmosphere: The calm waters and peaceful atmosphere make this place ideal for resting and finding peace
            </p>

            <p>
              Historical significance: The lake was originally a swamp and was flooded to create more land for the city's expansion.
            </p>

            <p>
              Horseback riding: Explore the lake's surroundings on horseback, a popular activity among visitors.
            </p>

            <p>
              Cool weather: The cold mountain climate enhances the charm of spending time by the lake.
            </p>

            <p>
              It is a wonderful place to visit if you find yourself in Nuwara Eliya, and it offers a combination of natural beauty and recreational opportunities.
            </p>

            <p>
              You can include this destinations in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience
            </p>

            <h2>Victoria park</h2>

            <p>
              Victoria Park, located in the heart of Nuwara Eliya, Sri Lanka,
              is one of the most beautiful and well-maintained city parks in the country.
              Named in honor of the 60th anniversary of Queen Victoria's reign in 1897,
              it is a favourite spot for both locals and tourists to enjoy the cool climate and the picturesque beauty of the mountainous region.
            </p>

            <h3>Highlights of Victoria Park:</h3>

            <p>
              Blooming: Known for its fantastic selection of flowers, especially during the blooming season. (March to May and August to September). There are roses, daisies, and various colorful flowers that create a lively atmosphere.
            </p>

            <p>
              Birdwatching: The park is home to many bird species, including some endemic ones, making it an ideal spot for birdwatchers.
            </p>

            <p>
              Recreational activities: Ideal for quiet walks, picnics, and photographs. The playground for children and the small attractions make it suitable for families.
            </p>

            <p>
              Natural environment: The picturesque paths, streams, and small bridges enhance the park's charm. The green vegetation and the cool climate make it a relaxing retreat.
            </p>

            <p>
              Historical significance: The park was initially used as a research site for exotic plants and was later transformed into a public garden.
            </p>

            <h3>Tips for the visit:</h3>

            <p>
              Best time to visit: In the morning or at dusk to enjoy a cooler climate and fewer people.
            </p>

            <p>
              Entrance: A reasonable fee is charged for both locals and tourists.
            </p>

            <p>
              Nearby attractions: Near Gregory Lake and the post office in Nuwara Eliya.
            </p>

            <p>
              Would you like tips on nearby places or seasonal attractions in the park?
            </p>

            <p>
              You can include this destinations in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience
            </p>

            <h2>Hakgala botanical garden</h2>

            <p>
              The Hakgala Botanical Garden, located near Nuwara Eliya, is one of the most beautiful gardens in Sri Lanka,
              known for its cool climate and vibrant floral compositions. Covering an area of 28 hectares,
              it offers an impressive collection of roses, orchids, ferns, and camellias, as well as exotic plants from around the world.
            </p>

            <p>
              The garden is part of the Hakgala Nature Reserve and offers picturesque views of the misty mountains and green landscapes.
              Its tranquil atmosphere makes it an ideal place to relax and photograph, attracting both nature lovers and tourists year-round.
            </p>

            <h3>Highlights of the Hakgala Botanical Garden:</h3>

            <p>
              Floral diversity: Known for its rose garden, orchids, and camellias.
              The seasonal flowers include warm flowers, such as dahlias and chrysanthemums.
            </p>

            <p>
              Historical significance: Initially founded in 1861 as a cinchona plantation (used for quinine production) and later transformed into a botanical garden.
            </p>

            <p>
              Mythological connection: Related to the legend of the Ramayana; it was supposed to be the pleasure garden of King Ravana, where they kept Sita devi.
            </p>

            <p>
              Cool climate: The high altitude and misty climate create a unique environment for a variety of temperate and subtropical plants.
            </p>

            <p>
              Panoramic beauty: Surrounded by the Hakgala mountain range and with views of rolling hills and valleys.
            </p>

            <p>
              Fauna: Frequent sightings of endemic birds and small animals, such as monkeys and squirrels.
            </p>

            <p>
              Tips for the visit: The best time to visit: from April to August, when most of the flowers are in full bloom.
            </p>

            <p>
              Duration: Spend 1 to 2 hours exploring the garden at a leisurely pace.
            </p>

            <p>
              Accessibility: The garden has well-maintained paths, but it is recommended to wear comfortable shoes for the uneven terrain.
            </p>

            <p>
              You can include this destinations in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience
            </p>

            <h2>Ambewela farm- Little New Zealand</h2>

            <p>
              The Ambevela farm, located near Nuwara Eliya, is often called "Little New Zealand" due to its green pastures,
              cool climate, and dairy production landscape.
              This is one of the most famous dairy farms in Sri Lanka and a popular tourist destination.
            </p>

            <h3>Highlights at Ambewela Farm:</h3>

            <p>
              Picturesque landscapes: Wavy green fields,
              cool breezes, and misty hills create a picturesque atmosphere. Perfect for photography and relaxation.
            </p>

            <p>
              Milk production: Known for the production of fresh milk, cheese, yogurt, and other dairy products.
              Visitors can observe modern methods of milk production and see how cows are milked.
            </p>

            <p>
              Fresh products: You can buy fresh dairy products directly from the farm, including milk and cheese.
            </p>

            <p>
              Interaction with animals: The farm has cows, calves, goats, and rabbits. Visitors, especially children, love to watch and interact with these animals.
            </p>

            <p>
              Tips for the visit: Best time to visit: Early in the morning or late in the evening for a pleasant climate and better agricultural activities.
            </p>

            <p>
              Duration: A typical visit lasts about 1-2 hours.
            </p>

            <p>
              Nearby attractions: Combine your visit with a trip to Horton Plains, Hakgala Botanical Garden, or the strawberry farm in this area.
            </p>

            <p>
              You can include this destinations in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience
            </p>

            <h2>Sethaamman temple</h2>

            <p>
              The Sita Amman Temple, also known as Sita Eliya Sita Amman Tirukovil, is an ancient Hindu Vaishnavite temple located in the Nuwara Eliya district of central Sri Lanka.
              The temple is closely associated with the Hindu epic Ramayana.
              According to legend, it was here that Ravana, the king of demons, held Sita, Lord Rama's wife, captive.
            </p>

            <h3>Highlights of seetha amman temple; Connection to the Ramayana:</h3>

            <p>
              The temple is dedicated to Sita, the wife of Lord Rama. According to legend,
              this is the place where King Ravana held Sita captive during her abduction.
              The nearest stream, according to legend, is the place where Sita bathed.
            </p>

            <h3>Holy footprint:</h3>

            <p>
              It is said that there are footprints related to Lord Hanuman in the rock by the stream.
            </p>

            <h3>Brilliant architecture:</h3>

            <p>
              The temple is adorned with vibrant Dravidian paintings and sculptures of Hindu gods, particularly Lord Rama, Sita, Lakshmana, and Hanuman.
            </p>

            <h3>Calm environment:</h3>

            <p>
              Hidden among the lush vegetation, the temple and its surroundings offer a peaceful environment for prayer and contemplation.
            </p>

            <h3>Cultural significance:</h3>

            <p>
              It is an important stop on the Ramayana trail in Sri Lanka, attracting pilgrims from India and other countries.
            </p>

            <h3>Tips for the visit:</h3>

            <p>
              Dress code: It is recommended to wear modest clothing that covers the shoulders and knees.
              Best time to visit: in the morning or afternoon for a calmer experience.
              Accessibility: The temple is easily accessible by car from the city of Nuwara Eliya.
              in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience
            </p>

            <h2>Golf club</h2>

            <p>
              Nuwara Eliya Golf Club is one of the oldest golf clubs in Sri Lanka, founded in 1889.
              Located in the heart of Nuwara Eliya, this historic club offers a picturesque golfing experience amidst greenery,
              the cool climate, and the impressive mountain views.
              It is a favorite spot for both professional golfers and visitors seeking relaxation in a tranquil environment.
            </p>

            <h3>Attractions of the Nuwara Eliya Golf Club:</h3>

            <h3>Rich history:</h3>

            <p>
              Created during the British colonial era, the club preserves its old-fashioned charm with colonial architecture
              and traditions. One of the oldest golf clubs in Asia.
              Beautiful course: 18-hole course that stretches over 6,399 yards,
              with fairways lined by tall trees and strategically placed bunkers to challenge the players.
              The high location adds a unique touch to the golfing experience.
              The club's services: Includes a cozy restaurant, bar, and lounge to relax after the match.
              Offers equipment rental for those who travel without their own gear.
              Captivating view: Surrounded by mist-covered hills, tea plantations, and the charming town of Nuwara Eliya,
              the club is as picturesque as it is relaxing. Accessibility: Open to members and non-members,
              making it convenient for tourists to enjoy the game.
              Tips for the visit: Reservations: It is recommended to make a reservation in advance,
              especially during peak season. (April-July). Dress code: Normally,
              a style of relaxed elegance is required on the golf course and in the clubhouse.
              The nearest attractions: close to Gregory Lake and Victoria Park,
              which facilitates the exploration of other attractions in Nuwara Eliya.
            </p>

            <h3>in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience.</h3>

            <h2>Moon plains</h2>

            <p>
              Also known as Sadathenna. Moon Plains is a picturesque mountain range located near Nuwara Eliya, Sri Lanka,
              known for its panoramic views and unique biodiversity. It is a relatively new ecotourism attraction and has quickly become popular among nature lovers and photographers. Previously, this area was used for potato cultivation, but it has been transformed into a sustainable ecological zone. Highlights in Moon Plains: 360-degree viewpoint (Mini World's End): Offers an impressive view of Sri Lanka's central mountains, including Piduruthalagala, Kirigalpotta, and Totapola. On clear days, you can even see the southern coast in the distance. Wildlife and biodiversity: Home to animals such as moose, deer, wild boar, and rare leopards. A fantastic place for birdwatching, with endemic and migratory birds often visiting this area. Tea plantations and grasslands: The green hills and lush landscapes create a picturesque atmosphere, perfect for resting or taking photos. Jeep safari: Visitors can explore the plains on a jeep safari with a guide who takes them to viewpoints and other prominent locations. Cool climate: The high altitude provides a pleasant and cool temperature year-round. Tips for the visit: Best time: The early morning hours for clear views and better chances to see wildlife.
              Duration: A typical visit lasts about 1-2 hours. Access: Located approximately 4 km from the town of Nuwara Eliya;
            </p>

            <h3>in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience.</h3>

            <h2>Pedro tea state</h2>

            <p>
              The Pedro Tea Estate, located approximately 3.5 km from the town of Nuwara Eliya, is a historic tea plantation and factory that offers visitors an insight into Sri Lanka's world-renowned tea industry. Surrounded by rolling hills and lush plantations, this estate is a must-visit for tea lovers and those interested in the production process.
            </p>

            <p>
              The factory was founded in 1885 and is a testament to the tea heritage from Sri Lanka's colonial era.
            </p>

            <p>
              Attractions at the Pedro Tea Plantation:
            </p>

            <p>
              once you visit ,you will learn the entire tea production process, from picking the leaves to drying, rolling, fermenting, and packaging.
            </p>

            <p>
              Observe the traditional methods of tea production that are still used today.
            </p>

            <p>
              Tastings: Enjoy the freshly brewed Ceylon tea and experience its unparalleled taste and aroma. Historical significance: Picturesque plantations: Walks through the picturesque tea plantations, often shrouded in mist, offer excellent opportunities for photography. Cool climate: The high altitude creates a refreshing atmosphere, perfect for exploration. Tips for the visit: Best time: Morning hours for the excursion and the observation of the workers who are actively picking the tea leaves. Duration: The visit usually takes 1 to 2 hours. Photography: Photography is usually not allowed inside the factory, but it is permitted in the surrounding fields. Main attractions nearby: Combine your visit with Gregory Lake, the Lovers Leap waterfall, or the Hakgala Botanical Garden.
            </p>

            <h3>in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience.</h3>

            <h2>Ramboda fall</h2>

            <p>
              The Ramboda waterfall is not only a beautiful natural wonder but also an important tourist attraction in the Nuwara Eliya region.
            </p>

            <p>
              Here are some of them: Picturesque views and photography Panoramic landscapes: The waterfalls are surrounded by green tea plantations and hills covered in mist, creating a picturesque environment, perfect for photography.
            </p>

            <p>
              Viewpoints: Around the waterfalls, there are several spots where visitors can enjoy the best views and take memorable photographs.
            </p>

            <p>
              Recreational activities Hiking and trekking: The area around Ramboda Falls offers several hiking trails and trekking opportunities, allowing visitors to explore the natural beauty of the region.
            </p>

            <p>
              Nature walks: Enjoy a peaceful walk through the surrounding forests and tea plantations, and soak in the atmosphere of tranquillity.
            </p>

            <p>
              Nearby attractions The Ramboda Tunnel: Just a few minutes from the waterfalls lies the Ramboda Tunnel, one of the longest tunnels in Sri Lanka, which is an interesting engineering marvel to admire.
            </p>

            <p>
              Tea plantations: The nearest tea plantations offer excursions where you can learn about tea production and enjoy fresh Ceylon tea.
            </p>

            <p>
              Local culture and history The region is rich in cultural history, with various local traditions and customs that visitors can get to know during their visit.
            </p>

            <p>
              The visit to Ramboda Falls offers a combination of natural beauty, recreational activities, and cultural experiences, making it an integral part of the journey in Sri Lanka.
              Whether you are an adventure seeker, a nature lover, or someone who wants to relax and enjoy the tranquility,
              Ramboda Falls offers something for everyone.
            </p>

            <p>
              Whether you're seeking adventure, love nature, or just want to relax and enjoy the tranquility, Ramboda Falls has something for everyone.
            </p>

            <p>
              In your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience.
            </p>

            <h2>Damro Tea factory</h2>

            <p>
              Damro tea factory, located in the mountainous regions of Sri Lanka, is a popular place for tea lovers and those interested in the tea production process.
            </p>

            <h3>Highlights from the Damro Tea Factory</h3>

            <p>
              Guided tour of the tea factory Offers guided tours that explain the entire tea production process, from picking to processing.
              Visitors can see the machines in action and learn about the classification of tea.
            </p>

            <p>
              Tea tasting Enjoy freshly brewed Ceylon tea and discover the flavors that have made Sri Lankan tea famous worldwide.
            </p>

            <p>
              Picturesque views The factory is surrounded by picturesque tea plantations with mountainous landscapes and misty views.
            </p>

            <p>
              Purchase of tea You can buy high-quality tea directly from the source, which guarantees its authenticity.
            </p>

            <p>
              Cultural understanding A surprising way to understand the history of tea and its significance for Sri Lanka's economy and culture.
            </p>

            <p>
              Convenient location It is often visited on the way to destinations such as Nuwara Eliya or Ramboda.
            </p>

            <p>
              Visiting the Damro tea factory offers an experience that is both educational and sensory, perfect for travellers exploring the tea plantations in Sri Lanka.
            </p>

            <p>
              You can include this destinations in your travel itinerary which we Ceylon Grace Travels will give you unforgettable experience
            </p>

          </div>

          {/* ACTIVITIES SECTION */}
          <div className="mirissa-activities" data-aos="fade-up">

            <details className="activity-box" open>
              <summary>• Nature and Science Exploration</summary>

              <p>
                Discover Nuwara Eliya's breathtaking landscapes, from misty mountains to lush tea plantations. Iconic spots like Horton Plains, Moon Plains, and Gregory Lake offer captivating views and serene environments perfect for nature enthusiasts and photographers alike.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={hortonPlains} alt="Horton Plains" />
                  <p>Horton Plains</p>
                </div>

                <div className="activity-card">
                  <img src={moonPlains} alt="Moon Plains" />
                  <p>Moon Plains</p>
                </div>

                <div className="activity-card">
                  <img src={gregoryLake} alt="Gregory Lake" />
                  <p>Gregory Lake</p>
                </div>
              </div>
            </details>

            <details className="activity-box">
              <summary>• Cultural and Historical Landmarkes</summary>

              <p>
                Explore the cultural richness of Nuwara Eliya through attractions like the Sita Amman Temple, colonial-era Golf Club, and Victoria Park. These sites provide a blend of history, mythology, and architectural charm, reflecting the area’s unique heritage.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={sitaTemple} alt="Sita Amman Temple" />
                  <p>Sita Amman Temple</p>
                </div>

                <div className="activity-card">
                  <img src={golfClub} alt="Golf Club" />
                  <p>Golf Club</p>
                </div>

                <div className="activity-card">
                  <img src={victoriaPark} alt="Victoria Park" />
                  <p>Victoria Park</p>
                </div>
              </div>
            </details>

            <details className="activity-box">
              <summary>• Leisure and Adventure Activities</summary>

              <p>
                Engage in thrilling adventures and leisure pursuits. Enjoy scenic train rides, hike near waterfalls, visit Ambewela Farm, or take a boat ride on Gregory Lake. Nuwara Eliya caters to both relaxation seekers and adventure enthusiasts.
              </p>

              <div className="activity-gallery">
                <div className="activity-card">
                  <img src={trainRides} alt="Train Rides" />
                  <p>Train Rides</p>
                </div>

                <div className="activity-card">
                  <img src={waterfalls} alt="Waterfalls" />
                  <p>Waterfalls</p>
                </div>

                <div className="activity-card">
                  <img src={ambewelaFarm} alt="Turtle Feeding" />
                  <p>Ambewela Farm</p>
                </div>
              </div>
            </details>
          </div>

          {/* PARROT ROCK SECTION */}
          <div className="mirissa-parrot-rock" data-aos="fade-up">

            <div className="parrot-gallery">
              <img src={n6} alt="Parrot Rock Beach" />
              <img src={n7} alt="Seafood Dish" />
            </div>

          </div>

        </div>

        {/* RIGHT INQUIRY FORM */}
        <div className="mirissa-form" data-aos="fade-left">
          <h3>Make an Inquiry</h3>

          <form
            onSubmit={(e) => {
              e.preventDefault();

              const name = e.target.name.value;
              const email = e.target.email.value;
              const country = e.target.country.value;
              const code = e.target.code.value;
              const phone = e.target.phone.value;
              const arrival = e.target.arrival.value;
              const departure = e.target.departure.value;
              const interest = e.target.interest.value;
              const vehicle = e.target.vehicle.value;   // ✅ NEW
              const adults = e.target.adults.value;
              const kids = e.target.kids.value;
              const message = e.target.message.value;

              const fullMessage = `
                📌 NEW TOUR BOOKING

                👤 Name: ${name}
                📧 Email: ${email}
                🌍 Country: ${country}
                📞 Phone: ${code} ${phone}
                📅 Arrival: ${arrival}
                📅 Departure: ${departure}
                🎯 Interest: ${interest}
                🚗 Vehicle Preference: ${vehicle}
                👨‍👩‍👧 Adults: ${adults}
                🧒 Kids: ${kids}

                💬 Message: ${message} 
              `;

              // ✅ SEND WHATSAPP
              const whatsappNumber = "94717726099"; // your WhatsApp number
              const whatsappURL =
                "https://wa.me/" + whatsappNumber + "?text=" + encodeURIComponent(fullMessage);

              window.open(whatsappURL, "_blank");

              // ✅ SEND EMAIL
              const mailto =
                "mailto:ceylongracetravels@gmail.com" +
                "?subject=" + encodeURIComponent("New Tour Booking") +
                "&body=" + encodeURIComponent(fullMessage);

              window.location.href = mailto;

              alert("✅ Your Booking is Send!");
            }}
          >
            <input name="name" type="text" placeholder="Name *" />
            <input name="email" type="email" placeholder="Email Address *" />

            <select name="country" required>
              <option value="">Choose Your Country *</option>
              <option value="Afghanistan">Afghanistan</option>
              <option value="Albania">Albania</option>
              <option value="Algeria">Algeria</option>
              <option value="Andorra">Andorra</option>
              <option value="Angola">Angola</option>
              <option value="Antigua and Barbuda">Antigua and Barbuda</option>
              <option value="Argentina">Argentina</option>
              <option value="Armenia">Armenia</option>
              <option value="Australia">Australia</option>
              <option value="Austria">Austria</option>
              <option value="Azerbaijan">Azerbaijan</option>
              <option value="Bahamas">Bahamas</option>
              <option value="Bahrain">Bahrain</option>
              <option value="Bangladesh">Bangladesh</option>
              <option value="Barbados">Barbados</option>
              <option value="Belarus">Belarus</option>
              <option value="Belgium">Belgium</option>
              <option value="Belize">Belize</option>
              <option value="Benin">Benin</option>
              <option value="Bhutan">Bhutan</option>
              <option value="Bolivia">Bolivia</option>
              <option value="Bosnia and Herzegovina">Bosnia and Herzegovina</option>
              <option value="Botswana">Botswana</option>
              <option value="Brazil">Brazil</option>
              <option value="Brunei">Brunei</option>
              <option value="Bulgaria">Bulgaria</option>
              <option value="Burkina Faso">Burkina Faso</option>
              <option value="Burundi">Burundi</option>
              <option value="Cabo Verde">Cabo Verde</option>
              <option value="Cambodia">Cambodia</option>
              <option value="Cameroon">Cameroon</option>
              <option value="Canada">Canada</option>
              <option value="Central African Republic">Central African Republic</option>
              <option value="Chad">Chad</option>
              <option value="Chile">Chile</option>
              <option value="China">China</option>
              <option value="Colombia">Colombia</option>
              <option value="Comoros">Comoros</option>
              <option value="Congo, Democratic Republic of the">Congo, Democratic Republic of the</option>
              <option value="Congo, Republic of the">Congo, Republic of the</option>
              <option value="Costa Rica">Costa Rica</option>
              <option value="Côte d’Ivoire">Côte d’Ivoire</option>
              <option value="Croatia">Croatia</option>
              <option value="Cuba">Cuba</option>
              <option value="Cyprus">Cyprus</option>
              <option value="Czech Republic">Czech Republic</option>
              <option value="Denmark">Denmark</option>
              <option value="Djibouti">Djibouti</option>
              <option value="Dominica">Dominica</option>
              <option value="Dominican Republic">Dominican Republic</option>
              <option value="Ecuador">Ecuador</option>
              <option value="Egypt">Egypt</option>
              <option value="El Salvador">El Salvador</option>
              <option value="Equatorial Guinea">Equatorial Guinea</option>
              <option value="Eritrea">Eritrea</option>
              <option value="Estonia">Estonia</option>
              <option value="Eswatini">Eswatini</option>
              <option value="Ethiopia">Ethiopia</option>
              <option value="Fiji">Fiji</option>
              <option value="Finland">Finland</option>
              <option value="France">France</option>
              <option value="Gabon">Gabon</option>
              <option value="Gambia">Gambia</option>
              <option value="Georgia">Georgia</option>
              <option value="Germany">Germany</option>
              <option value="Ghana">Ghana</option>
              <option value="Greece">Greece</option>
              <option value="Grenada">Grenada</option>
              <option value="Guatemala">Guatemala</option>
              <option value="Guinea">Guinea</option>
              <option value="Guinea-Bissau">Guinea-Bissau</option>
              <option value="Guyana">Guyana</option>
              <option value="Haiti">Haiti</option>
              <option value="Honduras">Honduras</option>
              <option value="Hungary">Hungary</option>
              <option value="Iceland">Iceland</option>
              <option value="India">India</option>
              <option value="Indonesia">Indonesia</option>
              <option value="Iran">Iran</option>
              <option value="Iraq">Iraq</option>
              <option value="Ireland">Ireland</option>
              <option value="Israel">Israel</option>
              <option value="Italy">Italy</option>
              <option value="Jamaica">Jamaica</option>
              <option value="Japan">Japan</option>
              <option value="Jordan">Jordan</option>
              <option value="Kazakhstan">Kazakhstan</option>
              <option value="Kenya">Kenya</option>
              <option value="Kiribati">Kiribati</option>
              <option value="Korea, North">Korea, North</option>
              <option value="Korea, South">Korea, South</option>
              <option value="Kuwait">Kuwait</option>
              <option value="Kyrgyzstan">Kyrgyzstan</option>
              <option value="Laos">Laos</option>
              <option value="Latvia">Latvia</option>
              <option value="Lebanon">Lebanon</option>
              <option value="Lesotho">Lesotho</option>
              <option value="Liberia">Liberia</option>
              <option value="Libya">Libya</option>
              <option value="Liechtenstein">Liechtenstein</option>
              <option value="Lithuania">Lithuania</option>
              <option value="Luxembourg">Luxembourg</option>
              <option value="Madagascar">Madagascar</option>
              <option value="Malawi">Malawi</option>
              <option value="Malaysia">Malaysia</option>
              <option value="Maldives">Maldives</option>
              <option value="Mali">Mali</option>
              <option value="Malta">Malta</option>
              <option value="Marshall Islands">Marshall Islands</option>
              <option value="Mauritania">Mauritania</option>
              <option value="Mauritius">Mauritius</option>
              <option value="Mexico">Mexico</option>
              <option value="Micronesia">Micronesia</option>
              <option value="Moldova">Moldova</option>
              <option value="Monaco">Monaco</option>
              <option value="Mongolia">Mongolia</option>
              <option value="Montenegro">Montenegro</option>
              <option value="Morocco">Morocco</option>
              <option value="Mozambique">Mozambique</option>
              <option value="Myanmar (Burma)">Myanmar (Burma)</option>
              <option value="Namibia">Namibia</option>
              <option value="Nauru">Nauru</option>
              <option value="Nepal">Nepal</option>
              <option value="Netherlands">Netherlands</option>
              <option value="New Zealand">New Zealand</option>
              <option value="Nicaragua">Nicaragua</option>
              <option value="Niger">Niger</option>
              <option value="Nigeria">Nigeria</option>
              <option value="North Macedonia">North Macedonia</option>
              <option value="Norway">Norway</option>
              <option value="Oman">Oman</option>
              <option value="Pakistan">Pakistan</option>
              <option value="Palau">Palau</option>
              <option value="Panama">Panama</option>
              <option value="Papua New Guinea">Papua New Guinea</option>
              <option value="Paraguay">Paraguay</option>
              <option value="Peru">Peru</option>
              <option value="Philippines">Philippines</option>
              <option value="Poland">Poland</option>
              <option value="Portugal">Portugal</option>
              <option value="Qatar">Qatar</option>
              <option value="Romania">Romania</option>
              <option value="Russia">Russia</option>
              <option value="Rwanda">Rwanda</option>
              <option value="Saint Kitts and Nevis">Saint Kitts and Nevis</option>
              <option value="Saint Lucia">Saint Lucia</option>
              <option value="Saint Vincent and the Grenadines">Saint Vincent and the Grenadines</option>
              <option value="Samoa">Samoa</option>
              <option value="San Marino">San Marino</option>
              <option value="Sao Tome and Principe">Sao Tome and Principe</option>
              <option value="Saudi Arabia">Saudi Arabia</option>
              <option value="Senegal">Senegal</option>
              <option value="Serbia">Serbia</option>
              <option value="Seychelles">Seychelles</option>
              <option value="Sierra Leone">Sierra Leone</option>
              <option value="Singapore">Singapore</option>
              <option value="Slovakia">Slovakia</option>
              <option value="Slovenia">Slovenia</option>
              <option value="Solomon Islands">Solomon Islands</option>
              <option value="Somalia">Somalia</option>
              <option value="South Africa">South Africa</option>
              <option value="South Sudan">South Sudan</option>
              <option value="Spain">Spain</option>
              <option value="Sri Lanka">Sri Lanka</option>
              <option value="Sudan">Sudan</option>
              <option value="Suriname">Suriname</option>
              <option value="Sweden">Sweden</option>
              <option value="Switzerland">Switzerland</option>
              <option value="Syria">Syria</option>
              <option value="Taiwan">Taiwan</option>
              <option value="Tajikistan">Tajikistan</option>
              <option value="Tanzania">Tanzania</option>
              <option value="Thailand">Thailand</option>
              <option value="Timor-Leste">Timor-Leste</option>
              <option value="Togo">Togo</option>
              <option value="Tonga">Tonga</option>
              <option value="Trinidad and Tobago">Trinidad and Tobago</option>
              <option value="Tunisia">Tunisia</option>
              <option value="Turkey">Turkey</option>
              <option value="Turkmenistan">Turkmenistan</option>
              <option value="Tuvalu">Tuvalu</option>
              <option value="Uganda">Uganda</option>
              <option value="Ukraine">Ukraine</option>
              <option value="United Arab Emirates">United Arab Emirates</option>
              <option value="United Kingdom">United Kingdom</option>
              <option value="United States">United States</option>
              <option value="Uruguay">Uruguay</option>
              <option value="Uzbekistan">Uzbekistan</option>
              <option value="Vanuatu">Vanuatu</option>
              <option value="Vatican City">Vatican City</option>
              <option value="Venezuela">Venezuela</option>
              <option value="Vietnam">Vietnam</option>
              <option value="Yemen">Yemen</option>
              <option value="Zambia">Zambia</option>
              <option value="Zimbabwe">Zimbabwe</option>
            </select>

            <div className="phone-row">
              <input name="code" className="code" type="text" placeholder="Code" />
              <input name="phone" className="phone" type="text" placeholder="Phone Number *" />
            </div>

            <label htmlFor="arrival">Arrival Date</label>
            <input name="arrival" type="date" />

            <label htmlFor="departure">Departure Date</label>
            <input name="departure" type="date" />

            <select name="interest">
              <option value="">Choose Your Interest *</option>
              <option value="Eco">Eco</option>
              <option value="Beach">Beach</option>
              <option value="Cultural">Cultural</option>
              <option value="Adventure">Adventure</option>
              <option value="Wild Life">Wild Life</option>
              <option value="Relax and Wellness">Relax and Wellness</option>
              <option value="Honeymoon">Honeymoon</option>
              <option value="Ramayana Trail">Ramayana Trail</option>
              <option value="All in one Trails">All in one Trails</option>
            </select>

            <select name="vehicle">
              <option value="">Select Vehicle Type *</option>
              <option value="Sedan – Toyota Prius (3 Pax)">Sedan – Toyota Prius (3 Pax)</option>
              <option value="Sedan – Toyota Axio (3 Pax)">Sedan – Toyota Axio (3 Pax)</option>
              <option value="Sedan – Honda Grace (3 Pax)">Sedan – Honda Grace (3 Pax)</option>
              <option value="Mini – Suzuki Wagon R (2 Pax)">Mini – Suzuki Wagon R (2 Pax)</option>
              <option value="Mini – Toyota Aqua (2 Pax)">Mini – Toyota Aqua (2 Pax)</option>
              <option value="Van – Suzuki Every (4 Pax)">Van – Suzuki Every (4 Pax)</option>
              <option value="Van – Mini Van (4 Pax)">Van – Mini Van (4 Pax)</option>
              <option value="Van – Toyota Noha (4 Pax)">Van – Toyota Noha (4 Pax)</option>
              <option value="Bus – Mitsubishi Rosa (12 Pax)">Bus – Mitsubishi Rosa (12 Pax)</option>
              <option value="Bus – King Long (12 Pax)">Bus – King Long (12 Pax)</option>
            </select>

            <input name="adults" type="number" placeholder="Adults *" />
            <input name="kids" type="number" placeholder="Kids" />

            <textarea name="message" placeholder="Enter your message"></textarea>

            <button type="submit">SUBMIT</button>
          </form>

        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section" data-aos="fade-up">
        <div className="cta-box">
          <div className="cta-left">
            <img src={require("../../assets/hile.png")} className="cta-icon" alt="icon" />
            <div className="cta-text">
              <h2>Ready To Adventure And Enjoy Natural</h2>
              <p>Reach Ceylon Grace Travels For A Secure, Luxurious, And Unforgettable Adventure!</p>
            </div>
          </div>

          <img src={require("../../assets/plan.png")} className="cta-plane" alt="plane" />

          <button className="cta-btn">LET’S GET STARTED</button>
        </div>
      </section>
    </div>
  );
}

export default NuwaraEliya;
